import { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  body: {
    maxWidth: '100%',
    height: '3.75rem',
    padding: '0.625rem 0 0.625rem 1.25rem',
    borderRadius: '0.7875rem',
    boxShadow: '0 0 0.625rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.313rem',
      height: '3.75rem',
      backgroundColor: '#c0c6cb',
      zIndex: '9',
    },
  },
  Strip: {
    height: '0.625rem',
    borderRadius: '0.475rem',
    backgroundColor: '#F4F4F5',
  },
  title: {
    height: '3.563rem',
    backgroundColor: '#4073d2',
    borderRadius: '10.1px',
    padding: '0.875rem 0 0.75rem 1.563rem',
    marginBottom: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.423rem',
    letterSpacing: 0,
    color: theme.palette.font.white,
    fontWeight: '600',
  },
}));

export default memo(function OnDutyCard({ title, accept, index, triggerFunction }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        <div className={classes.Strip} style={{ width: '13.875rem' }} />
        <div className={classes.Strip} style={{ width: '8.5rem', margin: '0.313rem 0' }} />
        <div className={classes.Strip} style={{ width: '2.938rem' }} />
      </div>
    </div>
  );
});
